// extracted by mini-css-extract-plugin
export default {"wrapper":"OperationAnalysisReport_wrapper__zTFiX","page":"OperationAnalysisReport_page__Qi6IX"};